export default __webpack_public_path__ + "static/media/note.687fe65b.png";